import {html} from "Application.js";
import {Directive, directive} from "lit/directive.js";

export const MIN_YEAR = 1970;
export const MAX_YEAR = new Date().getFullYear() + 50;

export const getMoneyDecimal = (amount) => {
	if(typeof amount === "string") {
		amount = amount.replace(/\.00$/, ""); // Remove decimal .00 part
		amount = parseInt(amount); // Turn into number
	}

	return amount;
};

class FormatMoney extends Directive {

	render(value) {
		if(value === null || value === undefined)
			return html`-`;

		value = getMoneyDecimal(value);

		return html`${Utils.PrefixedNumberFormatter("" + value, 2)}`;
	}

}

export const formatMoney = directive(FormatMoney);
